export enum IpcPhases {
  PHASE_1 = 'Phase 1: Minimal',
  PHASE_2 = 'Phase 2: Stressed',
  PHASE_3 = 'Phase 3: Crisis',
  PHASE_4 = 'Phase 4: Emergency',
  PHASE_5 = 'Phase 5: Famine',
}
